// extracted by mini-css-extract-plugin
export default {"dropdown":"Dropdown_dropdown__Y+Idf","trigger":"Dropdown_trigger__wfCzL","panel":"Dropdown_panel__Bidvx"};